export default "__VITE_ASSET__CVm8suTK__"